<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.addRepeatingEvent") }}</h3>
            </div>
            <div class="card-body p-0">
                <form ref="form" class="p-4 row">
                    <div class="col-12 mt-2">
                        <label for="interval" class="form-label">{{ $t("repeatingEvents.intervalDays") }}</label>
                        <input type="number" class="form-control" id="interval" v-model="repeatingEvent.interval_days" required>
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label for="repeatFrom" class="form-label">{{ $t("repeatingEvents.repeatFrom") }}</label>
                        <input
                            type="date"
                            class="form-control"
                            id="repeatFrom"
                            v-model="repeatingEvent.repeat_from"
                            required
                            :min="today"
                            :class="{ 'is-invalid': isInvalidFrom }"
                        >
                    </div>
                    <div class="col-12 col-md-6 mt-2">
                        <label for="repeatTo" class="form-label">{{ $t("repeatingEvents.repeatTo") }}</label>
                        <input
                            type="date"
                            class="form-control"
                            id="repeatTo"
                            v-model="repeatingEvent.repeat_to"
                            required
                            :min="repeatingEvent.repeat_from || today"
                            :class="{ 'is-invalid': isInvalidDateRange }"
                        >
                    </div>
                    <p class="form-text mb-0">* {{ $t("utils.requiredFields") }}</p>
                </form>
            </div>
        </div>

        <div class="my-4">
            <button
                class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white"
                @click="submitForm"
            >
                {{ $t("utils.save") }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            repeatingEvent: {
                interval_days: 1,
                repeat_from: null,
                repeat_to: null,
            },
            vehicleEntry: {},
            guestbook: {},
            commodities: [],
        }
    },
    created() {
        if (this.$route.name === "AddRepeatingEvent_VehicleEntry") {
            this.getVehicleEntry();
        }

        if (this.$route.name === "AddRepeatingEvent_Guestbook") {
            this.getGuestbook();
        }
    },
    methods: {
        getVehicleEntry() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/${this.$route.params.id}`)
                .then(response => {
                    this.vehicleEntry = response.data;
                    this.getCommodities();
                })
                .catch(error => {
                    console.error("Error loading vehicle entry", error);
                });
        },
        getCommodities() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/vehicle-entries/${this.vehicleEntry.id}/commodities`)
                .then(response => {
                    this.commodities = response.data;
                })
                .catch(error => {
                    console.error("Error loading commodities", error)
                });
        },
        getGuestbook() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/guestbooks/${this.$route.params.id}`)
                .then(response => {
                    this.guestbook = response.data;
                })
                .catch(error => {
                    console.error("Error loading guestbook", error);
                });
        },
        validateForm() {
            if (this.$refs.form.checkValidity() === false){
                this.$refs.form.reportValidity();
                return false;
            }

            if (this.isInvalidFrom || this.isInvalidDateRange) {
                return false;
            }

            return true;
        },
        submitForm() {
            if (!this.validateForm()) return;

            const type = this.$route.name.includes("Guestbook") ? "guestbook" : "vehicle_entry";
            const eventId = this.$route.params.id;

            const formData = {
                interval_days: this.repeatingEvent.interval_days,
                repeat_from: this.repeatingEvent.repeat_from,
                repeat_to: this.repeatingEvent.repeat_to,
                event_type: type,
                event_id: eventId,
            };

            this.$store.getters.api.post(`/${this.$route.params.slug}/repeating-events/add`, formData)
            .then(() => {
                this.$router.push({
                    name: "RepeatingEvents",
                    params: {
                        slug: this.$route.params.slug,
                    }
                });
            })
            .catch(error => {
                console.error("Error adding repeating event", error);
            });
        }
    },
    computed: {
        today() {
            return new Date().toISOString().slice(0, 10);
        },
        isInvalidFrom() {
            if (!this.repeatingEvent.repeat_from) return false;

            return this.repeatingEvent.repeat_from < this.today;
        },
        isInvalidDateRange() {
            if (!this.repeatingEvent.repeat_from || !this.repeatingEvent.repeat_to) return false;

            const from = new Date(this.repeatingEvent.repeat_from);
            const to = new Date(this.repeatingEvent.repeat_to);

            return to <= from;
        }
    }
}
</script>

<style lang="">

</style>